export const SECONDARY_ACTIONS = {
  START: 'start',
  PAUSE: 'pause',
  CANCEL: 'cancel',
};
